import type { EmvGlobalConfigurationDto } from "src/app/features/EmvGlobalConfiguration/types/EmvGlobalConfigurationDto";
import type { EmvGlobalConfigurationEntity } from "src/app/features/EmvGlobalConfiguration/types/EmvGlobalConfigurationEntity";

export const EmvGlobalConfigurationDtoToEntity = ({ ...rest }: Readonly<EmvGlobalConfigurationDto>): EmvGlobalConfigurationEntity => {
    return { ...rest };
};
